module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-welth.e63a2887.png";